export const skillsData = [
    {
        label: "Languages",
        data: [
            {
                skillName: "C++",
                percentage: "90",
            },
            {
                skillName: "Python",
                percentage: "85",
            },
            {
                skillName: "JavaScript",
                percentage: "80",
            },
            {
                skillName: "Java",
                percentage: "65",
            },
        ],
    },
    
    {
        label: "Frontend",
        data: [
            {
                skillName: "HTML",
                percentage: "90",
            },
            {
                skillName: "CSS",
                percentage: "95",
            },
            {
                skillName: "ReactJs",
                percentage: "80",
            },
        ],
    },

    {
        label: "Frameworks/libraries",
        data: [
            {
                skillName: "Node.js",
                percentage: "90"
            },
            {
                skillName: "Express.js",
                percentage: "90"
            },
             {
                skillName: "FastAPI",
                percentage: "75"
            },
            {
                skillName: "NumPy",
                percentage: "80"
            },
             {
                skillName: "Pandas",
                percentage: "80"
            },
            {
                skillName: "Matplotlib/Seaborn",
                percentage: "80"
            },
            {
                skillName: "Scikit-learn",
                percentage: "70"
            },
        ],
    },

    {
        label: "Databases",
        data: [
            {
                skillName: "MongoDB",
                percentage: "85"
            },
            {
                skillName: "SQL",
                percentage: "90"
            },
        ],
    },
];